/**
 * @license
 * Copyright (c) 2022 Handsoncode. All rights reserved.
 */
import { ErrorType } from '../Cell';
import { Transformer } from './Transformer';
export class CleanOutOfScopeDependenciesTransformer extends Transformer {
    constructor(sheet) {
        super();
        this.sheet = sheet;
    }
    isIrreversible() {
        return true;
    }
    fixNodeAddress(address) {
        return address;
    }
    transformCellAddress(dependencyAddress, formulaAddress) {
        return dependencyAddress.isInvalid(formulaAddress) ? ErrorType.REF : false;
    }
    transformCellRange(start, end, formulaAddress) {
        return start.isInvalid(formulaAddress) || end.isInvalid(formulaAddress) ? ErrorType.REF : false;
    }
    transformColumnRange(start, end, formulaAddress) {
        return start.isInvalid(formulaAddress) || end.isInvalid(formulaAddress) ? ErrorType.REF : false;
    }
    transformRowRange(start, end, formulaAddress) {
        return start.isInvalid(formulaAddress) || end.isInvalid(formulaAddress) ? ErrorType.REF : false;
    }
}
